import { render, staticRenderFns } from "./CDetail.vue?vue&type=template&id=37d9db6b&"
import script from "./CDetail.vue?vue&type=script&lang=ts&"
export * from "./CDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports